import dayjs from 'dayjs';
import Analytics from '../../system/Analytics';
import MiscUtils from '../../utils/MiscUtils';
import AccountService from '../Account';
import { Parent, Account, StudentStatus } from '../Account/types';
import { OldAPI } from '../OldClient';
import { OnboardingCreateAccountDto, OnboardingDto, OnboardingStudentDto } from '../Onboarding/types';
import { User } from './types';

namespace UserService {
  export async function getUser(
    loadParent?: boolean,
    shouldLoadFundingAccounts?: boolean
  ): Promise<User | undefined> {
    const user: User = {};

    let account;

    try {
      account = await AccountService.getAccount();
    } catch (e) {
      // if (e?.message === 'Network Error') {
      //   return { error: 'NETWORK_ERROR' };
      // }
      throw new Error("Account could not be loaded");
    }

    if (!account) {
      // Sentry.captureMessage(`Error getting account with id:${id}`, Sentry.Severity.Error);
      return;
    }
    user.account = account;

    let parent = {};

    if (account.sponsorId) {
      // if a sponsor exists

      // load funding accounts
      if (shouldLoadFundingAccounts) {
        // try {
        //     dispatch(loadFundingAccounts());
        // } catch (e) {
        //     Sentry.captureMessage(`error loading funding accounts:: ${e?.message}`);
        // }
      }

      // load the sponsor
      if (loadParent) {
        try {
          parent = await AccountService.getParent();
          user.parent = parent as Parent;
        } catch (e) {
          // Sentry.captureMessage('error loading account sponsor::', e?.message);
        }
      }
    }

    const parentData = user?.parent?.email
      ? {
        sponsorEmail: user?.parent?.email || account.sponsorEmail || '',
        sponsorPhoneNumber: user?.parent?.phoneNumber || account.sponsorPhoneNumber || '',
        sponsorName: parent
          ? `${user?.parent?.firstName} ${user?.parent?.lastName}`
          : account?.sponsorName || '',
      }
      : {};

    const identifyData = {
      ...account,
      ...parentData,
    };

    Analytics.identify(account.id as string, identifyData);

    // group the child acc by the account groupId
    if (account.groupId) {
      Analytics.group(account.groupId, MiscUtils.prependKeysToObject(account as any, 'child:'));
    }

    return user;

  }

  export async function createUser(account: Partial<OnboardingCreateAccountDto>): Promise<void> {
    try {
      const phoneNumber = account?.phoneNumber?.replace(/[ \(\)\-]/g, '') || '';
      await OldAPI.post<Account>('/accounts', {
        accountInfo: {
          name: account?.firstName + ' ' + account?.lastName,
          firstName: account?.firstName,
          lastName: account?.lastName,
          email: account?.email,
          birthday: account?.birthday,
          phoneNumber,
          country: 'US',
          attributionSource: 'web',
          alpacaId: '',
        }
      })
    } catch (error: Error | any) {
      console.log(error)
      throw new Error(error.message)
    }
  }

  export async function upsertUser(account: Partial<OnboardingDto>): Promise<void> {
    try {
      await OldAPI.patch<Account>('/accounts', {
        accountUpdateInfo: account.accountUpdateInfo
      })
    } catch (error: Error | any) {
      console.log(error)
      throw new Error(error.message)
    }
  }

  export async function updateStudentInfo(account: OnboardingDto): Promise<void> {
    try {
      await OldAPI.patch<Account, {}, OnboardingStudentDto>('/accounts', {
        accountUpdateInfo: account.accountUpdateInfo
      })
    } catch (error: Error | any) {
      throw new Error(error.message)
    }
  }
}

export default UserService;
